type BaseEnum = Record<string, unknown>;

export const isEnumValue = <T extends BaseEnum>(
  enumObj: T,
  value: any
): value is T[keyof T] => {
  return Object.values(enumObj).includes(value);
};

export const asEnumValue = <T extends BaseEnum>(
  enumObj: T,
  value: any
): T[keyof T] | null => {
  if (isEnumValue(enumObj, value)) {
    return value;
  }

  return null;
};
